// ISO alpha-2 codes of the countries AOP offers whose postal codes are digits only,
// so a mobile number pad can never keep an applicant from typing their code. Every
// other country -- and an absent or unrecognized one -- falls back to the full
// keyboard, which is the behavior everywhere outside this list.
const numericPostalCodeCountries = new Set([
  'AM', 'AT', 'AU', 'BE', 'BG', 'BH', 'BR', 'BT', 'CH', 'CL',
  'CN', 'CO', 'CR', 'CV', 'CY', 'CZ', 'DE', 'DK', 'DO', 'EC',
  'EE', 'EG', 'ES', 'FI', 'FM', 'FR', 'GE', 'GL', 'GR', 'GT',
  'GU', 'HN', 'HR', 'HU', 'ID', 'IL', 'IS', 'IT', 'JO', 'JP',
  'KR', 'KW', 'LA', 'LI', 'LS', 'LU', 'MC', 'MH', 'MN', 'MQ',
  'MX', 'MY', 'NO', 'NZ', 'OM', 'PE', 'PG', 'PH', 'PL', 'PR',
  'PT', 'PW', 'PY', 'RO', 'SA', 'SE', 'SG', 'SI', 'SK', 'SM',
  'SV', 'TH', 'TR', 'TT', 'TW', 'US', 'UY', 'VI', 'ZA',
]);

// inputMode only hints which keyboard a mobile browser opens. It never restricts what
// the field accepts, so a pasted or already-saved code keeps working either way.
const zipInputMode = country => (numericPostalCodeCountries.has(country) ? 'numeric' : 'text');

export default zipInputMode;
export { numericPostalCodeCountries };
